export const APP_TOD = 'tod';
export const APP_AR = 'ar';
export const APP_DEMO_ITB = 'demo_itb';
export const APP_DEMO = 'demo';
export const APP_MUZA = 'muza';
export const APP_IMJ = 'imj';
export const APP_IMJ_DEMO = 'imj-demo'; 
export const APP_AGAM = 'agam';
export const APP_ANNEFRANK = 'annefranktour'
export const APP_ANNEFRANK_REV = 'annefranktour-rev'

export const ANNEFRANK_CHAPTER_BREAKS: Record<number, string> = {
    0: 'pages.chapter_one',
    12: 'pages.chapter_two',
};

export const ANNEFRANK_CHAT_CONTEXTS: Record<string, string> = {
    'Station 0': 'The user is at Station 0 — Welcome. Tour introduction, Anne\'s statue, safety, community loss.',
    'Station 1': 'The user is at Station 1 — The Secret Annex. Legacy, memory, hope, resilience, diary.',
    'Station 2': 'The user is at Station 2 — The Memory of Music. Music, survival, homecoming, cultural loss.',
    'Station 3': 'The user is at Station 3 — The House of Detention. Imprisonment, resistance, execution, sacrifice.',
    'Station 4': 'The user is at Station 4 — The Helpers: Johannes Kleiman. Ordinary courage, business partnership, helpers.',
    'Station 5': 'The user is at Station 5 — Jewish Resistance. Armed resistance, sabotage, Jewish fighters, monuments.',
    'Station 6': 'The user is at Station 6 — Between Two Synagogues. Synagogues, Sephardic/Ashkenazi communities, February Strike.',
    'Station 6.1': 'The user is at Station 6.1 — Names Monument. Memorial site for Holocaust victims.',
    'Station 6.2': 'The user is at Station 6.2 — Shadow Quay. Memorial site along the canal.',
    'Station 7': 'The user is at Station 7 — The Heart of Ashkenazi Amsterdam. Jewish neighborhood, daily life, forced segregation.',
    'Station 8': 'The user is at Station 8 — A Separate Education. Education, segregation, children\'s restrictions, Margot.',
    'Station 9': 'The user is at Station 9 — Coffee, Culture and Courage. Socialist culture, intellectuals, Nazi invasion shock, café.',
    'Station 9.1': 'The user is at Station 9.1 — A Bridge Between Worlds. Cultural connection point.',
    'Station 10': 'The user is at Station 10 — Ice Cream Parlor Koco. Self-defense, resistance formation, February Strike catalyst.',
    'Station 10.1': 'The user is at Station 10.1 — One City, Two Storytellers. Jozef Israëls, art, observation, beauty in struggle.',
    'Station 11': 'The user is at Station 11 — The Helpers: Miep Gies. Helpers, hiding logistics, Miep\'s courage, diary preservation.',
    'Station 11.1': 'The user is at Station 11.1 — Neighborhood Synagogue. Synagogue, sacred spaces, yellow stars, persecution.',
    'Station 12': 'The user is at Station 12 — Anne\'s Journey. Anne\'s home, journey to hiding, stumblestones, tour intro.',
};
